module.exports = require("react-hot-loader");